export * from './major.actions';


// WEBPACK FOOTER //
// src/main/content/major/store/actions/index.js